export default __webpack_public_path__ + "static/screenshot-1-24f9425fe51171d57a4bf783a293eb98.png";